module.exports = __webpack_public_path__ + "static/media/halo-top.fd4908b1.png";